import MuiTableHead from "@mui/material/TableHead";
const TableHead = MuiTableHead;
export default TableHead;
